"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.render = exports.setOpen = exports.get = void 0;
var stringUtils_sidecar_1 = require("@lib/stringUtils-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageMessageInfoRequest_1 = require("@voyage/multi/voyageMessageInfoRequest");
var voyageMessageInfoRequest_sidecar_1 = require("@voyage/multi/voyageMessageInfoRequest-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyagePicker_sidecar_1 = require("@voyage/ui-cursors/voyagePicker-sidecar");
var voyageTestParams_sidecar_1 = require("@voyage/scene/voyageTestParams-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var voyageUiNav_sidecar_1 = require("@voyage/ui/voyageUiNav-sidecar");
var _showIds = false && voyageTestParams_sidecar_1.voyageTestParams.isDevMode;
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(true);
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 0;
    var th = 0;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiGame);
    canvas.autoOffset = false;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
    //slot: 1,
    //hoveredPart: null,
    });
    return obj;
};
var setOpen = function (isOpen) {
    var obj = get();
    // voyageUiCanvas.setOpen(obj, isOpen)
    // Hack: always hide
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, false);
};
exports.setOpen = setOpen;
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (voyageUiNav_sidecar_1.voyageUiNav.get().isOpen) {
        return;
    }
    var gb = voyageCamera_sidecar_1.voyageCamera.getGameBounds();
    var x = 60;
    var y = 60;
    // let w = gb.width - 150 * 2
    // let h = 200
    // x = 150
    // y = gb.height - h - 20
    var w = 500;
    var h = 300;
    var sy = y;
    var sx = x;
    var addText = function (text, ox, oy) {
        if (ox === void 0) { ox = 0; }
        if (oy === void 0) { oy = 0; }
        var t = voyageUiCanvas_sidecar_1.voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3);
        stevieTexts2_sidecar_1.stevieTexts2.setWrapWidth(t, w - 60);
        var ch = stevieTexts2_sidecar_1.stevieTexts2.getCurrentHeight(t);
        if (ch < 20) {
            ch = 20;
        }
        y += ch;
        return t;
    };
    var addSpacer = function () {
        y += 30;
    };
    // goatGraphicsUtils.bevelPanelBackground(g, x, y, w, h)
    var vp = voyagePicker_sidecar_1.voyagePicker.get();
    var cr = vp.hoveredCrew || vp.selectedCrew;
    // let sysTile = vp.hoveredSystem
    // let items = (vp.hoveredTile && vp.hoveredTile.items) || []
    var hoveredText = '';
    // if (vp.hoveredTile) {
    //   if (vp.hoveredTile.tile2.type === EVoyageTile.Chair) {
    //     hoveredText += 'Chair or Torpedo'
    //   }
    //   if (vp.hoveredTile.tile2.type === EVoyageTile.Table) {
    //     hoveredText += 'Table or Console'
    //   }
    // }
    var doShowInfoBar = false; // cr || sysTile || hoveredText || items.length > 0
    if (doShowInfoBar) {
        // voyageUiGraphicsUtils.bevelPanel2(g, x, y, w, h)
        //voyageUiGraphicsUtils.bevelPanelBackground(g, x, y, w, h, 16, 0)
        //voyageUiGraphicsUtils.bevelPanelOutline(g, x, y, w, h, 16, 0)
        addText('Info-matic 2000', 6, 0);
        y += 10;
        x += 30;
    }
    if (cr) {
        if (_showIds) {
            addText('ID: ' + cr.id);
        }
        if (cr.type === diveCrew_1.EVoyageCrewType.Hero) {
            addText('Crew Member');
            if (!cr.requestedInfo) {
                voyageMessageInfoRequest_sidecar_1.voyageMessageInfoRequest.sendMessageRequest({
                    type: voyageMessageInfoRequest_1.EInfoRequestType.Crew,
                    crewId: cr.id,
                    systemId: 0,
                });
            }
        }
        if (cr.type === diveCrew_1.EVoyageCrewType.Enemy) {
            addText('Alien');
        }
        if (cr.type === diveCrew_1.EVoyageCrewType.Fire) {
            addText('FIRE!');
            addSpacer();
            addText('Eats oxygen and spreads over time');
            addSpacer();
            addText('Move crew next to extinguish');
        }
        if (cr.type === diveCrew_1.EVoyageCrewType.HullBreach) {
            addText('Hull Breach!');
            addSpacer();
            addText('Leaks oxygen and gets bigger over time');
            addSpacer();
            addText('Move crew next to repair');
        }
        addSpacer();
        addText(cr.name);
        if (cr.title) {
            addText(cr.title);
        }
        addSpacer();
        //addText(cr.i + ',' + cr.j)
        addText('Health ' + stringUtils_sidecar_1.stringUtils.formatInteger(cr.hitpoints));
        if (cr.type === diveCrew_1.EVoyageCrewType.Hero) {
            addText('Energy ' + stringUtils_sidecar_1.stringUtils.formatInteger(cr.energy));
            if (cr.isPassedOut) {
                addText('Passed out from lack of sleep!');
            }
            if (cr.heroState) {
                addSpacer();
                var addStat = function (label, val) {
                    if (val) {
                        addText(label + ': ' + stringUtils_sidecar_1.stringUtils.formatInteger(val));
                    }
                };
                addStat('Kills', cr.heroState.statKills);
                addStat('Damage dealt', cr.heroState.statDamageGiven);
                addStat('Heals given', cr.heroState.statHeals);
                addStat('Repairs made', cr.heroState.statRepairs);
                addStat('Fires fought', cr.heroState.statFiresFought);
            }
        }
        addSpacer();
        addText(cr.info1);
        addSpacer();
        addSpacer();
    }
    // if (sysTile) {
    //   // addSpacer()
    //   //let sys = voyageTilemap.getSystemSafe(sysTile)
    //   if (sysTile && sysTile.system) {
    //     let sys = sysTile.system
    //     addText(sys.data.name)
    //     if (_showIds) {
    //       addText('ID: ' + sys.id)
    //     }
    //     addSpacer()
    //     addText('Subsystem (move crew here to use)')
    //     //addText(sysTile)
    //     addSpacer()
    //     if (!sys.requestedInfo) {
    //       voyageMessageInfoRequest.sendMessageRequest({
    //         type: EInfoRequestType.System,
    //         crewId: 0,
    //         systemId: sys.id,
    //       })
    //     }
    //     if (!sys.nickname) {
    //       addText('Fetching bio...')
    //     } else {
    //       addText("Nicknamed '" + sys.nickname + "'")
    //     }
    //     addSpacer()
    //     addText(sys.data.infoText)
    //     // if (sys.text3.startsWith('crematorium')) {
    //     //   addSpacer()
    //     //   addText('In space, no one can hear you scream.')
    //     //   addSpacer()
    //     //   addText('Trying to find a safe way to dispose of dead bodies?')
    //     //   addSpacer()
    //     //   addText('In space, no one can. Here, use crematorium.')
    //     //   addSpacer()
    //     // }
    //     if (sys.data.extraInfo) {
    //       addSpacer()
    //       addSpacer()
    //       addText(sys.data.extraInfo(sysTile))
    //     }
    //     addSpacer()
    //   } else {
    //     addText(sysTile.text3)
    //     addSpacer()
    //   }
    //   addSpacer()
    //   // addText(sys.info1)
    //   addSpacer()
    // }
    if (hoveredText) {
        addText(hoveredText);
        addSpacer();
    }
    // if (items.length > 0) {
    //   l.forEach(items, (c) => {
    //     addSpacer()
    //     addText('Item here: ' + c.data.name)
    //     if (_showIds) {
    //       addText('ID: ' + c.id)
    //     }
    //     addSpacer()
    //     addText(c.data.info)
    //     addSpacer()
    //   })
    // }
    if (doShowInfoBar) {
        if (y > h) {
            h = y + 50;
        }
        voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel2(g, sx, sy, w, h);
    }
    // goatUiFreeBuild_tooltipPart.render(obj)
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
exports.render = render;
var update = function () {
    var obj = get();
    if (obj.isOpen) {
        voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
        exports.render();
    }
};
exports.update = update;
